import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const CreateNoticeModal = ({ open, onClose, onCreateNotice }) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    
    if (!title.trim()) {
      newErrors.title = t('common:validation.required');
    }
    
    if (!content.trim()) {
      newErrors.content = t('common:validation.required');
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validate()) {
      onCreateNotice({
        title: title.trim(),
        content: content.trim()
      });
      
      // Reset form
      setTitle('');
      setContent('');
      setErrors({});
    }
  };

  const handleClose = () => {
    setTitle('');
    setContent('');
    setErrors({});
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>{t('common:actions.createNew')}</DialogTitle>
      
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box mb={3}>
            <TextField
              fullWidth
              label={t('common:fields.title')}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              error={Boolean(errors.title)}
              helperText={errors.title}
              variant="outlined"
              margin="normal"
            />
          </Box>
          
          <Box mb={2}>
            <TextField
              fullWidth
              label={t('common:fields.content')}
              value={content}
              onChange={(e) => setContent(e.target.value)}
              error={Boolean(errors.content)}
              helperText={errors.content}
              variant="outlined"
              margin="normal"
              multiline
              rows={6}
            />
          </Box>
          
          <Typography variant="caption" color="text.secondary">
            {t('common:messages.noticeHelpText')}
          </Typography>
          <Box mt={1}>
            <Typography variant="caption" color="primary">
              {t('common:messages.urlSupport')}
            </Typography>
          </Box>
        </DialogContent>
        
        <DialogActions>
          <Button onClick={handleClose}>{t('common:actions.cancel')}</Button>
          <Button 
            type="submit" 
            variant="contained" 
            color="primary"
          >
            {t('common:actions.create')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateNoticeModal; 